import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import NothingBox from 'components/NothingBox';
import Button from 'components/Button';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './PageMessage.module.scss';

const cn = classnames.bind(styles);

// Full-page state in place of the page content (render error, unavailable link) with one way out
const PageMessage = ({ titleId, descriptionId, actionLabelId, onAction }) => (
  <div className={cn('page-message')}>
    <NothingBox display icon="fa fa-warning">
      <FormattedMessage tagName="h1" id={titleId} />
      <FormattedMessage tagName="p" id={descriptionId} />
      <Button primary onClick={onAction}>
        <FormattedMessage id={actionLabelId} />
      </Button>
    </NothingBox>
  </div>
);

PageMessage.propTypes = {
  titleId: T.string.isRequired,
  descriptionId: T.string.isRequired,
  actionLabelId: T.string.isRequired,
  onAction: T.func.isRequired,
};

export default PageMessage;
